function openAccordion(accordionItem) {
    var contentElement = accordionItem.querySelector(".accordion__content");
    accordionItem.classList.add("accordion--active");
    contentElement.style.maxHeight = contentElement.scrollHeight + "px";
}

function closeAccordion(accordionItem) {
    var contentElement = accordionItem.querySelector(".accordion__content");
    accordionItem.classList.remove("accordion--active");
    contentElement.style.maxHeight = null;
}

function initializeAccordions() {
    var accordionItems = document.querySelectorAll(".accordion");

    accordionItems.forEach(function (item) {
        var headerElement = item.querySelector(".accordion__header"),
            contentElement = item.querySelector(".accordion__content");

        headerElement.onclick = function () {
            if (contentElement.style.maxHeight) {
                closeAccordion(item);
            } else {
                accordionItems.forEach(function (otherItem) {
                    return closeAccordion(otherItem);
                });
                openAccordion(item);
            }
        };
    });
}

export { openAccordion, closeAccordion, initializeAccordions };